import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Paper, Box, Typography, FormControl, RadioGroup, FormControlLabel,
} from '@material-ui/core';
import '../TargetSearchComponent';
import { SEARCH_TARGET_CONDITION } from '../../../../common/const';
import {
  setSearchTarget,
} from '../../../actions/TargetAction';
import styles from '../style.module.css';
import CustomRadio from '../../common/CustomRadio';

class SerchTargetParts extends Component {
  render() {
    const {
      searchTarget,
      setSearchTargetAct,
    } = this.props;

    return (
      <Box className={`${styles.parts}`}>
        <Paper elevation={0} className={`${styles.sectionBox}`}>
          <Box className={`${styles.alignItemsCenter} ${styles.displayFlex} ${styles.marginBottomTitle}`}>
            <Box className={`${styles.sectionTitleIcon} ${styles.marginRightHalf}`} />
            <Typography variant="h6" component="div" className={`${styles.sectionTitle}`}>検索対象</Typography>
          </Box>
          <FormControl component="fieldset">
            <RadioGroup row>
              <FormControlLabel
                value="honsya"
                control={<CustomRadio />}
                label="本社のみ"
                checked={searchTarget === SEARCH_TARGET_CONDITION.SEARCH_TARGET_ONE}
                onClick={() => setSearchTargetAct(SEARCH_TARGET_CONDITION.SEARCH_TARGET_ONE)}
              />
              <FormControlLabel
                value="jigyosyo"
                control={<CustomRadio />}
                label="事業所を含む"
                checked={searchTarget === SEARCH_TARGET_CONDITION.SEARCH_TARGET_ALL}
                onClick={() => setSearchTargetAct(SEARCH_TARGET_CONDITION.SEARCH_TARGET_ALL)}
                className={`${styles.marginLeft1}`}
              />
            </RadioGroup>
          </FormControl>
        </Paper>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    searchTarget: state.target.searchTarget,
  }),
  (dispatch) => ({
    setSearchTargetAct: (str) => dispatch(setSearchTarget(str)),
  }),
)(SerchTargetParts);
